module.exports = __webpack_public_path__ + "static/media/bigbuddah3.099aa74d.jpg";